import React, { useState } from "react";
import pdfIcon from "../assets/pdfIcon.png";
import fileIcon from "../assets/fileIcon.png";
import downloadIcon from "../assets/downloadIcon.png";
import lockIcon from "../assets/lockIcon.png";

const PdfUploadDownloadPayment = ({
  onUpload,
  onDownload,
  acceptImages = false,
}) => {
  const [isDownloadEnabled, setIsDownloadEnabled] = useState(false);

  const handleToggleDownload = () => {
    setIsDownloadEnabled(!isDownloadEnabled);
  };

  return (
    <div className="w-full flex flex-col items-center">
      <div className="flex items-center rounded-lg shadow-lg w-full md:p-2 2xl:p-6 justify-between bg-[#E8E9EB]">
        <div>
          <img
            src={acceptImages ? fileIcon : pdfIcon}
            alt="PDF icon"
            className="md:w-[30px] lg:w-[40px] xl:w-[50px] cursor-pointer"
            onClick={onDownload}
          />
        </div>
        <div className="md:text-xs lg:text-base md:ml-2">
          <p className="font-bold">
            Adicionar {acceptImages ? "Arquivo" : "PDF"}
          </p>
        </div>
        <div>
          <button
            type="button"
            className="flex-shrink-0"
            onClick={() => document.getElementById("fileInput").click()}
          >
            <img
              src={downloadIcon}
              alt="Upload icon"
              className="cursor-pointer"
            />
          </button>
          <input
            type="file"
            id="fileInput"
            style={{ display: "none" }}
            accept={
              acceptImages
                ? "application/pdf,image/jpeg,image/png,image/gif"
                : "application/pdf"
            }
            onChange={onUpload}
          />
        </div>
      </div>
    </div>
  );
};

export default PdfUploadDownloadPayment;
